import React from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 400,
      minHeight: 48,
      padding: '0 15px',
      [theme.breakpoints.down('xs')]: {
        minWidth: 100,
        minHeight: 35,
        fontSize: 12,
      },
    },
    label: {
      fontSize: 18,
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  }),
);

interface Props {
  onClick: any;
  fullWidth?: boolean;
  disabled?: boolean;
}

const SubmitButton: React.FC<Props> = ({ onClick, children, fullWidth = false, disabled = false }) => {
  const classes = useStyles();

  return (
    <Button
      onClick={onClick}
      variant="contained"
      color="primary"
      fullWidth={fullWidth}
      disabled={disabled}
      classes={{
        root: classes.root,
        label: classes.label,
      }}
    >
      {children}
      {` ${String.fromCharCode(187)}`}
    </Button>
  );
};

export default SubmitButton;
